import { createMockSlardar, getGlobalSlardarInitStatus } from "./utils/mock-global-slardar";
const MAX_CONTEXT_COUNT = 40;
const WARNING_CONTEXT_COUNT = 20;
class SlardarWeb {
  setGlobalSlardarName(name) {
    this._globalSlardarName = name;
    this._onSlardarLoaded();
  }
  _onSlardarLoaded() {
    if (!this._createNew) {
      return;
    }
    const { loaded, initPromise, instanceGetter } = getGlobalSlardarInitStatus(this._globalSlardarName);
    if (loaded) {
      const instance = instanceGetter().create();
      this._instanceGetter = () => instance;
      return;
    }
    const mockSlardar = createMockSlardar();
    this._instanceGetter = () => mockSlardar;
    initPromise.then(() => {
      const instance = instanceGetter().create();
      this._instanceGetter().flush(instance);
      this._instanceGetter = () => instance;
    }).catch(() => {
    });
  }
  get _instance() {
    return this._instanceGetter();
  }
  rawInstance() {
    return this._instance;
  }
  init(config) {
    return this._instance("init", config);
  }
  config(config) {
    return this._instance("config", config);
  }
  start() {
    return this._instance("start");
  }
  context(ctx) {
    if (!ctx)
      return;
    const instance = this._instance;
    let contextCount = 0;
    Object.keys(ctx).forEach((key) => {
      if (ctx[key] === void 0 || ctx[key] === null) {
        instance("context.delete", key);
      } else {
        instance("context.set", key, ctx[key]);
        contextCount++;
      }
    });
    if (contextCount > MAX_CONTEXT_COUNT) {
      setTimeout(() => {
        const err = Error(`Exceed slardar context maximum count ${MAX_CONTEXT_COUNT}. The number of your slardar context is ${contextCount}, slardar will drop all your events.`);
        console.error(err);
        throw err;
      }, 20);
      return;
    }
    if (process.env.NODE_ENV !== "production") {
      if (contextCount >= WARNING_CONTEXT_COUNT) {
        console.warn(`Exceed slardar context warning count ${WARNING_CONTEXT_COUNT}.
  The number of your slardar context is ${contextCount}, slardar context maximum count is ${MAX_CONTEXT_COUNT}.
  If your project exceeds the maximum, slardar will drop all your events.`);
      }
    }
  }
  sendPageview(pid) {
    return this._instance("sendPageview", pid);
  }
  captureException(error, extra, react) {
    this._instance("captureException", error, extra, react);
  }
  sendEvent(data) {
    this._instance("sendEvent", data);
  }
  sendLog(data) {
    this._instance("sendLog", data);
  }
  sendCustomPerfMetric(data) {
    this._instance("sendCustomPerfMetric", data);
  }
  on(event, callback) {
    return this._instance("on", event, callback);
  }
  create(prefix = "") {
    const slardar = new SlardarWeb(prefix);
    slardar.setGlobalSlardarName(this._globalSlardarName);
    return slardar;
  }
  constructor(prefix = "") {
    this._globalSlardarName = "SlardarWeb";
    this._instanceGetter = () => window[this._globalSlardarName];
    this._createNew = Boolean(prefix);
  }
}
export {
  SlardarWeb
};

//# sourceMappingURL=slardar-web.js.map